import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./RegistrationScreen.css";
import { auth, db } from "../firebase";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { doc, setDoc, serverTimestamp } from "firebase/firestore";

function RegistrationScreen() {
  const navigate = useNavigate();

  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [phone, setPhone] = useState("");
  const [subscribe, setSubscribe] = useState(false);
  const [journalist, setJournalist] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      alert("Passwords do not match!");
      return;
    }

    // ✅ Normalize email + reveal hidden spaces/casing issues
    const cleanEmail = email.trim().toLowerCase();
    console.log("EMAIL BEING SENT:", JSON.stringify(cleanEmail));
    console.log("PROJECT:", auth.app.options.projectId, auth.app.options.authDomain);

    try {
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        cleanEmail,
        password
      );

      const user = userCredential.user;

      await setDoc(doc(db, "users", user.uid), {
        fullName: fullName.trim(),
        email: cleanEmail,
        phone: phone.trim(),
        subscribe,
        journalist,
        createdAt: serverTimestamp(), // ✅ better than new Date()
      });

      alert("Registration successful!");
      navigate("/login");
    } catch (error) {
      console.error("Registration error:", error);

      // ✅ Use error.code (more reliable)
      if (error.code === "auth/email-already-in-use") {
        alert("This email is already registered. Please log in.");
        navigate("/login");
        return;
      }

      if (error.code === "auth/invalid-email") {
        alert("Email looks invalid. Please check it.");
        return;
      }

      if (error.code === "auth/weak-password") {
        alert("Password is too weak. Try 6+ characters.");
        return;
      }

      alert(error.message);
    }
  };

  return (
    <div className="register-container">
      <img src="logo.jpg" alt="Operation Border Lights" className="register-logo" />

      <h2 className="register-title">Create Account</h2>

      <form className="register-form" onSubmit={handleSubmit}>
        <label htmlFor="fullName">Full Name</label>
        <input
          id="fullName"
          type="text"
          placeholder="Full Name"
          required
          value={fullName}
          onChange={(e) => setFullName(e.target.value)}
        />

        <label htmlFor="email">Email</label>
        <input
          id="email"
          type="email"
          placeholder="Email"
          required
          value={email}
          autoComplete="off"   // ✅ helps prevent autofill weirdness
          onChange={(e) => setEmail(e.target.value)}
        />

        <label htmlFor="password">Password</label>
        <input
          id="password"
          type="password"
          placeholder="Password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <label htmlFor="confirmPassword">Confirm Password</label>
        <input
          id="confirmPassword"
          type="password"
          placeholder="Confirm Password"
          required
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />

        <label htmlFor="phone">Phone</label>
        <input
          id="phone"
          type="tel"
          placeholder="Phone"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
        />

        <div className="checkbox-row">
          <input
            type="checkbox"
            id="subscribe"
            checked={subscribe}
            onChange={(e) => setSubscribe(e.target.checked)}
          />
          <label htmlFor="subscribe">Subscribe to news</label>
        </div>

        <div className="checkbox-row">
          <input
            type="checkbox"
            id="journalist"
            checked={journalist}
            onChange={(e) => setJournalist(e.target.checked)}
          />
          <label htmlFor="journalist">I am a journalist</label>
        </div>

        <button type="submit">Register</button>
      </form>

      <div className="already-account">
        Already have an account? <Link to="/login">Log In</Link>
      </div>
    </div>
  );
}

export default RegistrationScreen;
